import { lazy, Suspense, useCallback, useEffect, useState } from 'react';
import ItaliaMap from '../ItaliaMap';
import { ITALIA_GLB_DEFAULT } from './regionConfig';

const ItaliaMap3D = lazy(() => import('./ItaliaMap3D'));

const USE_3D = import.meta.env.VITE_ITALIA_MAP_3D === 'true';
const GLB_URL = import.meta.env.VITE_ITALIA_GLB_URL || ITALIA_GLB_DEFAULT;

/**
 * Facciata cartina: usa 3D se abilitato e GLB presente, altrimenti SVG.
 * API identica a ItaliaMap per uso drop-in in EsperienzaShop.
 */
export default function ItaliaMapView(props) {
  const [mode, setMode] = useState(USE_3D ? 'checking' : 'svg');

  useEffect(() => {
    if (!USE_3D) return;
    let cancelled = false;

    fetch(GLB_URL, { method: 'HEAD' })
      .then((res) => {
        if (cancelled) return;
        if (res.ok) {
          setMode('3d');
        } else {
          setMode('svg');
        }
      })
      .catch(() => {
        if (!cancelled) setMode('svg');
      });

    return () => { cancelled = true; };
  }, []);

  const handle3dError = useCallback(() => setMode('svg'), []);

  if (mode === 'checking') {
    return (
      <div className={`flex items-center justify-center bg-[#FFFEFA] rounded-xl ${props.className || ''}`}>
        <p className="text-xs text-[#9a5f2f] animate-pulse">Cartina…</p>
      </div>
    );
  }

  if (mode === '3d') {
    return (
      <Suspense
        fallback={(
          <div className={`flex items-center justify-center bg-[#FFFEFA] rounded-xl ${props.className || ''}`}>
            <p className="text-xs text-[#9a5f2f] animate-pulse">Cartina 3D…</p>
          </div>
        )}
      >
        <ItaliaMap3D
          {...props}
          glbUrl={GLB_URL}
          onLoadError={handle3dError}
        />
      </Suspense>
    );
  }

  return <ItaliaMap {...props} />;
}
